import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrEscrowPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_escrow'
        title='Escrow terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'escrow', subNavType: 'escrow', subNavPage: 'escrow' }}
      />
    )
  }
}

export default MasterLoanAgrEscrowPageSF
